import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrash, FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Configuracion from "../../../data/configuracion";
import DynamicIcon from "../../../components/DynamicIcon";
import ModalPermisosrol from "../../../components/ModalPermisosrol"; // Ajusta si está en otra ruta


export default function FormUsuarios({ autusuario }) {
  const [usuariosData, setUsuariosData] = useState([]); // Renombrado a usuariosData para mayor claridad
  const [errores, setErrores] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [nuevoUsuario, setNuevoUsuario] = useState({
    nombre: "",
    email: "",
    rolId: "",
  });
  const [mensaje, setMensaje] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [guardando, setGuardando] = useState(false);
  const usuariosPorPagina = 15;
  const [busqueda, setBusqueda] = useState("");
  const [usuarioAEliminar, setUsuarioAEliminar] = useState(null); // Renombrado a usuarioAEliminar
  const [showEliminarModal, setShowEliminarModal] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [sortColumn, setSortColumn] = useState("Nombre");
  const [sortDirection, setSortDirection] = useState("asc");

  const [showPermisosModal, setShowPermisosModal] = useState(false);
  const [permisosDelRol, setPermisosDelRol] = useState([]);
  const [rolesDisponibles, setRolesDisponibles] = useState([]);
  const [rolDeUsuarioSeleccionado, setRolDeUsuarioSeleccionado] = useState(null); // Nuevo estado para el rol del usuario

  useEffect(() => {
    cargarUsuarios();
    cargarRolesDisponibles();
  }, []);

  const cargarUsuarios = () => {
    if (
      !autusuario ||
      !autusuario.configuracion ||
      !autusuario.configuracion.proyecto ||
      !autusuario.email ||
      !autusuario.configuracion.basedatos
    ) {
      setErrores("Faltan datos del usuario para cargar usuarios");
      return;
    }

    axios
      .post(`${Configuracion.urlapi}/api/roles/getusuarios`, {
        appid: autusuario.configuracion.proyecto,
        email: autusuario.email,
        basedatos: autusuario.configuracion.basedatos,
      })
      .then((response) => {
        const datos = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data[0])
            ? response.data[0]
            : [];

        if (Array.isArray(datos)) {
          setUsuariosData(datos);
          setErrores(null);
        } else {
          setErrores("Respuesta inesperada del servidor");
          setUsuariosData([]);
        }
      })
      .catch(() => {
        setErrores("Error al cargar usuarios");
        setUsuariosData([]);
      });
  };

  const cargarRolesDisponibles = async () => {
    try {
      const response = await axios.post(`${Configuracion.urlapi}/api/roles/getroles`, {
        appid: autusuario.configuracion.proyecto,
        email: autusuario.email,
        basedatos: autusuario.configuracion.basedatos,
      });
      setRolesDisponibles(response.data);
    } catch (error) {
      console.error("Error al cargar roles disponibles:", error);
    }
  };

  const handleEditar = (id) => {
    const usuario = usuariosData.find((item) => item.Id === id);
    if (usuario) {
      setUsuarioEditando(usuario);
      setNuevoUsuario({
        nombre: usuario.Nombre,
        email: usuario.Email,
        rolId: usuario.RolId,
      });
      setMensaje("");
      setShowModal(true);
    }
  };
  
  const handlePermisos = (item) => {
    // Almacena el rol del usuario seleccionado para pasarlo al modal
    setRolDeUsuarioSeleccionado(item);
    setShowPermisosModal(true);
  };

  const handleEliminar = (id) => {
    const usuario = usuariosData.find((item) => item.Id === id);
    if (usuario) {
      setUsuarioAEliminar(usuario);
      setShowEliminarModal(true);
    }
  };

  const confirmarEliminar = async () => {
    if (!usuarioAEliminar) return;
    try {
      await axios.post(`${Configuracion.urlapi}/api/usuarios/deleteusuario`, {
        appid: autusuario.configuracion.proyecto,
        basedatos: autusuario.configuracion.basedatos,
        numid: usuarioAEliminar.Id,
      });
      cargarUsuarios();
      setShowEliminarModal(false);
      setUsuarioAEliminar(null);
    } catch (error) {
      setMensaje("Error eliminando el usuario.");
    }
  };

  const handleNuevoUsuario = () => {
    setNuevoUsuario({
      nombre: "",
      email: "",
      rolId: "",
    });
    setMensaje("");
    setUsuarioEditando(null);
    setShowModal(true);
  };

  const handleGuardarUsuario = async () => {
    const nombreTrimmed = nuevoUsuario.nombre.trim();
    const emailTrimmed = nuevoUsuario.email.trim();

    if (!nombreTrimmed || !emailTrimmed || !nuevoUsuario.rolId) {
      setMensaje("Todos los campos son obligatorios.");
      return;
    }

    if (
      !autusuario ||
      !autusuario.configuracion ||
      !autusuario.configuracion.proyecto ||
      !autusuario.email ||
      !autusuario.configuracion.basedatos
    ) {
      setMensaje("Faltan datos del usuario para guardar el usuario.");
      return;
    }

    const payload = {
      appid: autusuario.configuracion.proyecto,
      basedatos: autusuario.configuracion.basedatos,
      formusuario: {
        Nombre: nombreTrimmed,
        Email: emailTrimmed,
        RolId: nuevoUsuario.rolId,
      },
    };

    if (usuarioEditando) {
      payload.formusuario.Id = usuarioEditando.Id;
    }

    setGuardando(true);

    try {
      const endpoint = usuarioEditando
        ? `${Configuracion.urlapi}/api/usuarios/updateusuario`
        : `${Configuracion.urlapi}/api/usuarios/addusuario`;

      const response = await axios.post(endpoint, payload);

      if (response.data?.Resultado?.includes("duplicado")) {
        setMensaje("Ya existe un usuario con ese email.");
        return;
      }

      setShowModal(false);
      cargarUsuarios();
      setUsuarioEditando(null);
      setNuevoUsuario({
        nombre: "",
        email: "",
        rolId: "",
      });
      setMensaje("");
    } catch (error) {
      console.error("Error al guardar usuario:", error);
      setMensaje("Error al guardar el usuario.");
    } finally {
      setGuardando(false);
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
    setPaginaActual(1);
  };

  const filteredAndSortedUsuarios = Array.isArray(usuariosData)
    ? [...usuariosData]
      .filter((item) =>
        item.Nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.Email.toLowerCase().includes(busqueda.toLowerCase()) ||
        (item.NombreRol && item.NombreRol.toLowerCase().includes(busqueda.toLowerCase()))
      )
      .sort((a, b) => {
        const aValue = a[sortColumn];
        const bValue = b[sortColumn];
        if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
        if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
        return 0;
      })
    : [];

  const totalPaginas = Math.ceil(filteredAndSortedUsuarios.length / usuariosPorPagina);
  const usuariosPaginados = filteredAndSortedUsuarios.slice(
    (paginaActual - 1) * usuariosPorPagina,
    paginaActual * usuariosPorPagina
  );

  return (
    <div className="w-full mx-auto p-2 bg-white h-[90vh] overflow-y-auto">
      <h2 className="hidden text-2xl font-bold mb-2">Lista de Usuarios</h2>

      <div className="flex flex-wrap justify-center items-center mb-4 gap-2">
        <div className="flex space-x-2">
          <input
            type="text"
            value={busqueda}
            onChange={(e) => {
              setBusqueda(e.target.value);
              setPaginaActual(1);
            }}
            placeholder="Buscar Usuario..."
            className="hidden border border-gray-300 rounded px-3 py-2 w-64"
          />

          <button
            onClick={handleNuevoUsuario}
            className="flex items-center space-x-1 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded"
          >
            <span>Agregar Usuario</span>
          </button>

          <button
            onClick={() => {
              const dataExport = usuariosData.map((item) => ({
                Id: item.Id,
                Nombre: item.Nombre,
                Email: item.Email,
                Rol: item.NombreRol,
              }));
              const worksheet = XLSX.utils.json_to_sheet(dataExport);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Usuarios");
              const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
              });
              const blob = new Blob([excelBuffer], {
                type: "application/octet-stream",
              });
              saveAs(blob, "usuarios.xlsx");
            }}
            className="hidden flex items-center space-x-1 bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded"
          >
            <FaFileExcel />
            <span>Exportar Excel</span>
          </button>
        </div>
      </div>

      {errores && <p className="text-red-600">{errores}</p>}

      <table className="min-w-full table-auto">
        <thead className="bg-encabTabla-100 text-white sticky top-0 z-10">
          <tr>
            <th
              className="px-2 text-left cursor-pointer"
              onClick={() => handleSort("Nombre")}
            >
              Nombre usuario
              {sortColumn === "Nombre" && (
                <span className="ml-1">
                  {sortDirection === "asc" ? " ▲" : " ▼"}
                </span>
              )}
            </th>
            <th
              className="px-2 text-left cursor-pointer"
              onClick={() => handleSort("Email")}
            >
              Email
              {sortColumn === "Email" && (
                <span className="ml-1">
                  {sortDirection === "asc" ? " ▲" : " ▼"}
                </span>
              )}
            </th>
            <th
              className="px-2 text-left cursor-pointer"
              onClick={() => handleSort("NombreRol")}
            >
              Rol
              {sortColumn === "NombreRol" && (
                <span className="ml-1">
                  {sortDirection === "asc" ? " ▲" : " ▼"}
                </span>
              )}
            </th>
            <th className="px-2 text-left">Acción</th>
          </tr>
        </thead>
        <tbody>
          {usuariosPaginados.map((item, index) => (
            <tr
              key={index}
              className={
                index % 2 === 0
                  ? "bg-white hover:bg-gray-300"
                  : "bg-gray-100 hover:bg-gray-300"
              }
            >
              <td className="px-2">{item.Nombre}</td>
              <td className="px-2">{item.Email}</td>
              <td className="px-2">{item.NombreRol}</td>
              <td className="px-2">
                <div className="flex justify-center space-x-2">
                  {item.RolId !== 0 && (
                    <>
                      <button
                        onClick={() => handleEditar(item.Id)}
                        className="text-green-800 hover:underline"
                        title="Editar"
                      >
                        <DynamicIcon iconName="edit" size="1em" />
                      </button>
                      <button
                        onClick={() => handlePermisos(item)}
                        className="text-blue-600 hover:underline"
                        title="Permisos"
                      >
                        <DynamicIcon iconName="permisos" size="1em" />
                      </button>
                      <button
                        onClick={() => handleEliminar(item.Id)}
                        className="text-red-800 hover:underline"
                        title="Eliminar"
                      >
                        <DynamicIcon iconName="delete" size="1em" />
                      </button>
                    </>)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-center items-center space-x-2 mt-4">
        <button
          onClick={() => setPaginaActual((prev) => Math.max(prev - 1, 1))}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          disabled={paginaActual === 1}
        >
          Anterior
        </button>

        {[...Array(totalPaginas)].map((_, index) => (
          <button
            key={index}
            onClick={() => setPaginaActual(index + 1)}
            className={`px-3 py-1 rounded ${
              paginaActual === index + 1
                ? "bg-blue-500 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {index + 1}
          </button>
        ))}

        <button
          onClick={() =>
            setPaginaActual((prev) => Math.min(prev + 1, totalPaginas))
          }
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          disabled={paginaActual === totalPaginas}
        >
          Siguiente
        </button>
      </div>

      {/* Modal para nuevo/editar usuario */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
            <div className="bg-sidebar-200 rounded-t-md text-white pl-4 pt-1 font-bold h-[2rem]">
              {usuarioEditando ? "Editar Usuario" : "Nuevo Usuario"}
            </div>

            <label className="block mb-1 font-semibold mx-4 mt-2">
              Nombre:
            </label>
            <input
              type="text"
              value={nuevoUsuario.nombre}
              onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, nombre: e.target.value })}
              className="w-[90%] border border-gray-300 mx-4 px-4 py-2 rounded mb-2"
              placeholder="Nombre del usuario"
            />

            <label className="block mb-1 font-semibold mx-4 mt-2">
              Email:
            </label>
            <input
              type="email"
              value={nuevoUsuario.email}
              onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, email: e.target.value })}
              className="w-[90%] border border-gray-300 mx-4 px-4 py-2 rounded mb-2"
              placeholder="email@ejemplo.com"
            />

            <label className="block mb-1 font-semibold mx-4 mt-2">
              Rol:
            </label>
            <select
              value={nuevoUsuario.rolId}
              onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, rolId: e.target.value })}
              className="w-[90%] border border-gray-300 mx-4 px-4 py-2 rounded mb-2"
            >
              <option value="">Selecciona un rol</option>
              {rolesDisponibles.map((rol) => (
                <option key={rol.Id} value={rol.Id}>
                  {rol.NombreRol}
                </option>
              ))}
            </select>

            {mensaje && <p className="text-red-600 mb-2 mx-4">{mensaje}</p>}
            {guardando && (
              <p className="text-blue-600 font-medium mb-2 mx-4">Guardando...</p>
            )}

            <div className="flex justify-end space-x-2 px-4">
              <button
                onClick={() => {
                  setShowModal(false);
                  setUsuarioEditando(null);
                  setMensaje("");
                }}
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 mb-4 px-4 py-2 rounded"
              >
                Cancelar
              </button>
              <button
                onClick={handleGuardarUsuario}
                disabled={guardando}
                className="bg-green-600 hover:bg-green-700 text-white px-4 mb-4 mr-4 py-2 rounded"
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {showEliminarModal && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-titulo"
        >
          <div className="bg-white p-6 rounded-lg shadow-xl text-center w-[90%] max-w-md">
            <h2 id="modal-titulo" className="text-xl font-semibold mb-4">
              Confirmar eliminación de usuario
            </h2>
            <p className="mb-6">
              ¿Estás seguro de que deseas eliminar el usuario{" "}
              <strong>{usuarioAEliminar?.Nombre}</strong>?
            </p>
            <div className="flex justify-center gap-4">
              <button
                type="button"
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                onClick={confirmarEliminar}
              >
                Sí, eliminar usuario
              </button>
              <button
                type="button"
                className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400"
                onClick={() => setShowEliminarModal(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
{console.log(rolDeUsuarioSeleccionado)}
      <ModalPermisosrol
        isOpen={showPermisosModal}
        onClose={() => setShowPermisosModal(false)}
        selectedPermisos={rolDeUsuarioSeleccionado?.Permisos || []}
        rolId={rolDeUsuarioSeleccionado?.RolId || null}
        onSave={() => {
          setShowPermisosModal(false);
          cargarUsuarios(); // Recargar usuarios al guardar permisos
        }}
      />
    </div>
  );
}